<template>
    <div :class="`number-card ${state} ${selected ? 'selected' : ''}`" @click="goTo()">
        <div class="tooltip-bottom-right" v-if="tooltipIdentifier">
            <d-tooltip placement="inline" :identifier="tooltipIdentifier" />
        </div>
        <div class="icon">
            <i :class="'fad fa-' + icon + ' fa-fw'" />
        </div>
        <div class="number" :class="'colo__' + state">
            <count-to :startVal="0" :endVal="Number(number)" :duration="5000" ref="counter" :autoplay="true" v-if="number !== false" separator="." />
            <span v-else class="soon">
                Kommer snart
            </span>
        </div>
        <div class="heading">
            {{ heading }}
        </div>
        <div class="description">
            {{ description }}
        </div>
        <!--<div class="total" v-if="totalValue">
            Total: {{ totalValue | currency }}
        </div>-->
    </div>
</template>

<style lang="scss" scoped>
@import "../../styles/vars.scss";

    .tooltip-bottom-right {
        position: absolute;
        bottom: $padding--main / 2;
        right: $padding--main / 2;
    }

    .number-card {
        background: $color--white;
        padding: $padding--main / 2;
        border-radius: $borderradius--main;
        border: 1px solid $color--light;
        position: relative;
        // height: 100%;
        cursor: pointer;
        transition: $transition--main;
        min-height: 136px;

        &:hover,
        &.selected {
            border-color: $color--dark;
        }

        .icon {
            position: absolute;
            top: $padding--main / 2;
            right: $padding--main / 2;
            font-size: $fontsize--xl;
            opacity: .75;
        }

        .number {
            font-size: $fontsize--xl;
            font-weight: $fontweight--bold;
            margin-bottom: $margin--small / 2;
            font-family: $fontfamily--main;
            color: $color--main;
        }

        .heading {
            font-family: $fontfamily--main;
            font-weight: 600;
            margin-bottom: $margin--small / 4;
            font-size: $fontsize--main * 0.9;
        }

        .description {
            font-weight: $fontweight--light;
            font-size: $fontsize--sm;
        }

        .total {
            margin-top: 10px;
            // font-weight: $fontweight--bold;
            font-size: $fontsize--sm;
            color: $color--main;
            font-family: $fontfamily--main;
            font-weight: $fontweight--bold;
        }
    }

</style>

<script>
export default {
    data () {
        return {
            paused: true
        }
    },
    methods: {
        startCounter () {
            this.$refs.counter.start()
        },
        goTo () {
            if (this.doEmit) {
                this.$emit('clicked')
            } else {
                if (this.linkParent) {
                    this.$router.push({
                        name: this.linkParent,
                        params: {
                            selectedItem: this.linkChild
                        },
                        query: {
                            tab: this.linkChild
                        }
                    })
                }
            }
        }
    },
    props: [
        'heading',
        'description',
        'number',
        'icon',
        'state',
        'totalValue',
        'linkParent',
        'linkChild',
        'tooltipIdentifier',
        'doEmit',
        'selected'
    ]
}
</script>



// WEBPACK FOOTER //
// NumberCard.vue?8c135bec